import cmp from './ThemeCheckbox'

export default cmp
